import { Component } from '@angular/core';

@Component({
  selector: 'wellro-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'doctor';
}
